import PropTypes from 'prop-types';

/**
 *
 */
const documentsShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
});

/**
 *
 */
const entryShape = PropTypes.shape({
  documents: PropTypes.arrayOf(documentsShape).isRequired,
});

export { entryShape };
